import ModalService from "../../../common/services/modalService";

export default new ModalService();
